<template>
  <div class="btn-book">
    <a-button class="invoice" type="primary">Revise booking</a-button>
    <a-dropdown>
      <!-- @click="handleMenuClick" -->
      <a-menu slot="overlay">
        <a-menu-item key="1">
          Confirmation
        </a-menu-item>
        <a-menu-item key="2">
          Balance Reminder
        </a-menu-item>
      </a-menu>
      <a-button class="invoice" type="primary">Preview <a-icon type="down" /> </a-button>
    </a-dropdown>
    <a-button class="invoice" type="primary">Final checklist</a-button>
    <a-button class="invoice" type="primary">Travel document</a-button>
    <a-button class="invoice" type="primary">B4 tour greeting</a-button>
    <a-button class="invoice" type="primary">After tour greeting</a-button>
    <!-- @click="transferBooking" -->
    <a-button class="invoice" type="primary">Transfer Booking</a-button>
    <!-- @click="cancelBooking"" --> 
    <a-button class="invoice" type="primary">Cancel Booking</a-button>
  </div>
</template>

<script>

export default {
  name: 'BookBtn',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    handleButtonClick(e) {
      console.log('click  button', e)
    },
  }
}
</script>
<style lang="less" scoped>
.invoice {
  background: #da7139;
  border-color: #da7139;
}
.btn-book button {
  height: 28px;
  border-radius: 0;
  padding: 0 10px;
  margin-right: 10px;
}
</style>